import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Checkbox, Dimmer, Dropdown, Icon, Input, Loader, Modal } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
    getAtriutoAplicarListAction,
    getAtributoGeralAction,
    getAtributoDeleteAction,
    changeTabAction,
    getAtributoUpdateAction,
    getFabricanteListAction,
    getMarcaListAction,
    getLinhaListAction,
    getClassificacaoListAction,
    getAplicarEstAction,
    getAplicarEstBuscaAction,
    postAplicarEstAplicaAction
} from '../../../actions/EspacoTecaActions';

const Container = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  height: 300px;
  border: 1px solid #dededf;
  border-radius: 8px;
  overflow-y: auto;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f2f3f5;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 8px;
    transition: background 0.2s ease;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const CustomDropdown = styled(Dropdown)`
  &.ui.selection.dropdown:focus,
  &.ui.selection.dropdown.active {
    border-color: #102E3E !important;
    box-shadow: 0 0 0 1px #102E3E !important;
  }

  &.ui.selection.dropdown.active .dropdown.icon {
    color: #102E3E !important;
  }

  &.ui.selection.dropdown .menu {
    border: 2px solid #102E3E !important;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2) !important;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 0.9rem;
`;

const Th = styled.th`
  text-align: left;
  background: #102E3E;
  padding: 10px;
  color: #fff;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
`;

const Td = styled.td`
  padding: 5px 10px;
  border-bottom: 1px solid #eee;
  color: #444;
  vertical-align: middle;
`;

const Status = styled.span`
  width: '200px';
  padding: 6px 10px;
  border-radius: 6px;
  font-weight: 500;
  color: ${(props) =>
        props.value === "<vazio>"
            ? "#fff"
            : props.value === props.valorParaInput
                ? "#1a421a"
                : "#222"};
  background-color: ${(props) =>
        props.value === "<vazio>"
            ? "#e63946"
            : props.value === props.valorParaInput
                ? "#b7e4c7"
                : "#ffb703"};
`;

const ActionButton = styled(Button)`
  && {
    color: white;
    background-color: #D73A49;
    font-weight: 600;
    padding: 6px 8px;
    font-size: 0.85rem;
  }

  &&:hover {
    background-color: #B12E3B;
    color: white;
  }
`;
const ActionButtonSelect = styled(Button)`
  && {
    color: white !important;
    background-color: ${({ selected }) => (selected ? '#D73A49' : '#0078d7')} !important;
    font-weight: 600;
    padding: 6px 8px;
    font-size: 0.85rem;
    transition: background-color 0.15s ease;
  }

  &&:hover {
    background-color: ${({ selected }) => (selected ? '#B12E3B' : '#005ea3')} !important;
    color: white !important;
  }

  &&:focus,
  &&:active {
    background-color: ${({ selected }) => (selected ? '#D73A49' : '#0078d7')} !important;
    color: white !important;
    box-shadow: none !important;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background: #f8f9fb;
  border-top: 1px solid #dededf;
`;

const ApplyButton = styled(Button)`
  && {
    background: #0078d7;
    color: white;
    font-weight: 600;
    border-radius: 6px;
    padding: 8px 16px;
  }

  &&:hover {
    background: #005ea3;
  }
`;

const StyledModalHeader = styled(Modal.Header)`
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  padding-bottom: 0 !important;
  border-bottom: none !important;
`;

const ModalTitle = styled.h2`
  font-weight: 700 !important;
  margin-top: '10px' !important;
  margin-bottom: 1em !important;
`;

const StyledModalContent = styled(Modal.Content)`
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  text-align: center !important;
`;

const StyledModalActions = styled(Modal.Actions)`
  display: flex !important;
  justify-content: center !important;
  gap: 1rem !important;
  padding-bottom: 2em !important;
  border-top: none !important;
`;

const Tr = styled.tr`
  background-color: ${({ selected }) => (selected ? '#e6f3ff' : 'transparent')};
  transition: background-color 0.2s ease-in-out;
`;

function AplicarEst(props) {
    const {
        atributosItemList = [],
        atributosList = [],
        atributoSelecionado = null,
        tabindex,
        atributosAplicarList = [], // default safe
        atributosAplicarListLoading,
        atributosAplicarGeral,
        atributosAplicarGeralLoading,
        getAtriutoAplicarListAction, // from connect
        getAtributoGeralAction, // from connect
        getAtributoDeleteAction,
        atributosAplicarDelete,
        atributosAplicarDeleteLoading,
        atributosAplicarEdit,
        atributosAplicarEditLoading,
        getAtributoUpdateAction,
        fabricanteList,
        fabricanteListLoading,
        classificacaoList,
        classificacaoListLoading,
        marcaList,
        marcaListLoading,
        linhalist,
        linhalistLoading,
        getFabricanteListAction,
        getMarcaListAction,
        getLinhaListAction,
        getClassificacaoListAction,
        getAplicarEstAction,
        aplicarlistloading,
        aplicarest,
        getAplicarEstBuscaAction,
        aplicarbuscalistloading,
        aplicarestbusca,
        postAplicarEstAplicaAction,

    } = props;

    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [openModalExcluirSKU, setOpenModalExcluirSKU] = useState(false);
    const [skuExcluir, setSkuExcluir] = useState();
    const [loadingEditar, setLoadingEditar] = useState(false);
    const [reload, setReload] = useState(false);
    const [atributoValorIdExcluir, setAtributoValorIdExcluir] = useState();
    const [selecionados, setSelecionados] = useState([]); // SKUs selecionados (persistente entre filtros)
    const [todosSelecionados, setTodosSelecionados] = useState(false);
    const [selectedSku, setSelectedSku] = useState(false); // SKUs selecionados na tabela atual

    // filtros
    const [valorFiltroDigitado, setValorFiltroDigitado] = useState('');
    const [valorFiltro, setValorFiltro] = useState('');
    const [categoria, setCategoria] = useState('');
    const [sku, setSku] = useState('');
    const [produto, setProduto] = useState('');
    const [usarMesmoValor, setUsarMesmoValor] = useState(false);
    const [filtrosFabricante, setFiltrosFabricante] = useState({
        tecafabricanteid: '',   // NOTE: usar `atributoid` (sem "o") de forma consistente
        tecafabricante: '',
    });
    const [filtrosMarca, setFiltrosMarca] = useState({
        tecamarcaid: '',   // NOTE: usar `atributoid` (sem "o") de forma consistente
        tecamarca: '',
        produtos: ''
    });

    const [filtrosLinha, setFiltrosLinha] = useState({
        tecalinhaid: '',   // NOTE: usar `atributoid` (sem "o") de forma consistente
        tecalinha: '',
    });
    const [filtrosClassificacao, setFiltrosClassificacao] = useState({
        classificacaoid: '',   // NOTE: usar `atributoid` (sem "o") de forma consistente
        classificacao: '',
    });

    const [filtrosFabricanteBusca, setFiltrosFabricanteBusca] = useState({
        tecafabricanteid: '',   // NOTE: usar `atributoid` (sem "o") de forma consistente
        tecafabricante: '',
    });
    const [filtrosMarcaBusca, setFiltrosMarcaBusca] = useState({
        tecamarcaid: '',   // NOTE: usar `atributoid` (sem "o") de forma consistente
        tecamarca: '',
        produtos: ''
    });

    const [filtrosLinhaBusca, setFiltrosLinhaBusca] = useState({
        tecalinhaid: '',   // NOTE: usar `atributoid` (sem "o") de forma consistente
        tecalinha: '',
    });
    const [filtrosClassificacaoBusca, setFiltrosClassificacaoBusca] = useState({
        classificacaoid: '',   // NOTE: usar `atributoid` (sem "o") de forma consistente
        classificacao: '',
    });

    // refs separados para cada container/table
    const rootRef = useRef(null);
    const firstTableRef = useRef(null);
    const secondTableRef = useRef(null);

    // proteções e derived values
    const primeiroAtributoItem = atributosItemList && atributosItemList.length > 0 ? atributosItemList[0] : null;

    const valorParaInput = atributoSelecionado
        ? atributoSelecionado.tecaatributovalor
        : primeiroAtributoItem
            ? primeiroAtributoItem.tecaatributovalor
            : '';

    const valorParaInputId = atributoSelecionado
        ? atributoSelecionado.tecaatributovalorid
        : primeiroAtributoItem
            ? primeiroAtributoItem.tecaatributovaloroid
            : '';

    // quando primeiroAtributoItem estiver disponível, busca do backend
    // useEffect(() => {
    //     if (primeiroAtributoItem && primeiroAtributoItem.tecaatributoid) {
    //         getAtriutoAplicarListAction(primeiroAtributoItem.tecaatributoid, valorParaInput);
    //         getAtributoGeralAction(sku, categoria, valorFiltro, primeiroAtributoItem.tecaatributoid, primeiroAtributoItem.tecaatributoid);
    //     }
    //     // eslint-disable-next-line
    // }, [primeiroAtributoItem && primeiroAtributoItem.tecaatributoid, reload, atributosAplicarDeleteLoading]);

    // scroll quando muda a tab
    useEffect(() => {
        const APPLY_TAB_INDEX = 1;
        if (tabindex === APPLY_TAB_INDEX && rootRef.current) {
            rootRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            if (firstTableRef.current) firstTableRef.current.scrollTo({ top: 0, behavior: 'smooth' });
            if (secondTableRef.current) secondTableRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [tabindex]);

    useEffect(() => {
        getAplicarEstAction({ tecafabricanteid: null, tecamarcaid: null, tecalinhaid: null, classificacaoid: null, sku: null, titulo: null });
        getAplicarEstBuscaAction({ tecafabricanteid: null, tecamarcaid: null, tecalinhaid: null, classificacaoid: null, sku: null, titulo: null });
    }, [])


    // ---------- filtragem segura ----------
    // garante array seguro
    const listaSegura = Array.isArray(aplicarest) ? aplicarest : [];
    const exibeValorOuTraco = (valor) => (
        valor === null || valor === undefined || String(valor).trim() === '' ? '-' : valor
    );

    // define valorBusca (usar valorParaInput quando checkbox marcado)
    const valorBusca = usarMesmoValor ? (valorParaInput || '') : (valorFiltro || '');

    const handleChange = (e, { value }) => {

        if (!value) {
            const novo = {
                tecafabricanteid: '',
                tecafabricante: ''
            };
            setFiltrosFabricante(novo);
            try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { }
            return;
        }

        const atributoSelecionado = fabricanteOptions.find(opt => opt.value === value);

        const novoFiltros = {
            tecafabricanteid: atributoSelecionado?.key || '',
            tecafabricante: atributoSelecionado?.text || '',
        };

        setFiltrosFabricante(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        getMarcaListAction({ tecafabricanteid: novoFiltros.tecafabricanteid });

        getAplicarEstAction({ tecafabricanteid: novoFiltros.tecafabricanteid, tecamarcaid: null, tecalinhaid: null, classificacaoid: filtrosClassificacao.classificacaoid || null });

    };

    const handleChangeMarca = (e, { value }) => {

        if (!value) {
            const novo = {
                tecamarcaid: '',
                tecamarca: ''
            };
            setFiltrosMarca(novo);
            try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { }
            return;
        }

        const atributoSelecionado = marcaOptions.find(opt => opt.value === value);

        const novoFiltros = {
            tecamarcaid: atributoSelecionado?.key || '',
            tecamarca: atributoSelecionado?.text || '',
        };

        setFiltrosMarca(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        getLinhaListAction({ tecamarcaid: novoFiltros.tecamarcaid });

        getAplicarEstAction({ tecafabricanteid: filtrosFabricante.tecafabricanteid, tecamarcaid: novoFiltros.tecamarcaid, tecalinhaid: null, classificacaoid: filtrosClassificacao.classificacaoid || null });
    };

    const handleChangeLinha = (e, { value }) => {

        if (!value) {
            const novo = {
                tecalinhaid: '',
                tecalinha: ''
            };
            setFiltrosLinha(novo);
            try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { }
            return;
        }

        const atributoSelecionado = linhaOptions.find(opt => opt.value === value);

        const novoFiltros = {
            tecalinhaid: atributoSelecionado?.key || '',
            tecalinha: atributoSelecionado?.text || '',
        };

        setFiltrosLinha(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        // getLinhaListAction({ tecamarcaid: novoFiltros.tecamarcaid });
        getAplicarEstAction({ tecafabricanteid: filtrosFabricante.tecafabricanteid, tecamarcaid: filtrosMarca.tecamarcaid, tecalinhaid: novoFiltros.tecalinhaid, classificacaoid: filtrosClassificacao.classificacaoid || null });
    };

    const handleChangeClassificacao = (e, { value }) => {

        if (!value) {
            const novo = {
                classificacaoid: '',
                classificacao: ''
            };
            setFiltrosClassificacao(novo);
            try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { }
            getAplicarEstAction({
                tecafabricanteid: filtrosFabricante.tecafabricanteid || null,
                tecamarcaid: filtrosMarca.tecamarcaid || null,
                tecalinhaid: filtrosLinha.tecalinhaid || null,
                classificacaoid: null
            });
            return;
        }

        const atributoSelecionado = classificacaoOptions.find(opt => opt.value === value);

        const novoFiltros = {
            classificacaoid: atributoSelecionado?.key || '',
            classificacao: atributoSelecionado?.text || '',
        };

        setFiltrosClassificacao(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        getAplicarEstAction({
            tecafabricanteid: filtrosFabricante.tecafabricanteid || null,
            tecamarcaid: filtrosMarca.tecamarcaid || null,
            tecalinhaid: filtrosLinha.tecalinhaid || null,
            classificacaoid: novoFiltros.classificacaoid || null
        });
    };

    const handleChangeBusca = (e, { value }) => {

        if (!value) {
            const novo = {
                tecafabricanteid: '',
                tecafabricante: ''
            };
            setFiltrosFabricanteBusca(novo);
            try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { }
            return;
        }

        const atributoSelecionado = fabricanteOptions.find(opt => opt.value === value);

        const novoFiltros = {
            tecafabricanteid: atributoSelecionado?.key || '',
            tecafabricante: atributoSelecionado?.text || '',
        };

        setFiltrosFabricanteBusca(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        getMarcaListAction({ tecafabricanteid: novoFiltros.tecafabricanteid });
    };

    const handleChangeMarcaBusca = (e, { value }) => {

        if (!value) {
            const novo = {
                tecamarcaid: '',
                tecamarca: ''
            };
            setFiltrosMarcaBusca(novo);
            try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { }
            return;
        }

        const atributoSelecionado = marcaOptions.find(opt => opt.value === value);

        const novoFiltros = {
            tecamarcaid: atributoSelecionado?.key || '',
            tecamarca: atributoSelecionado?.text || '',
        };

        setFiltrosMarcaBusca(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        getLinhaListAction({ tecamarcaid: novoFiltros.tecamarcaid });
    };

    const handleChangeClassificacaoBusca = (e, { value }) => {

        if (!value) {
            const novo = {
                classificacaoid: '',
                classificacao: ''
            };
            setFiltrosClassificacaoBusca(novo);
            try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { }
            return;
        }

        const atributoSelecionado = classificacaoOptions.find(opt => opt.value === value);

        const novoFiltros = {
            classificacaoid: atributoSelecionado?.key || '',
            classificacao: atributoSelecionado?.text || '',
        };

        setFiltrosClassificacaoBusca(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        // getLinhaListAction({ tecamarcaid: novoFiltros.tecamarcaid });
    };

    const handleChangeLinhaBusca = (e, { value }) => {

        if (!value) {
            const novo = {
                tecalinhaid: '',
                tecalinha: ''
            };
            setFiltrosLinhaBusca(novo);
            try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { }
            return;
        }

        const atributoSelecionado = linhaOptions.find(opt => opt.value === value);

        const novoFiltros = {
            tecalinhaid: atributoSelecionado?.key || '',
            tecalinha: atributoSelecionado?.text || '',
        };

        setFiltrosLinhaBusca(novoFiltros);

        // carrega os itens do atributo via action (comportamento atual)
        // getLinhaListAction({ tecamarcaid: novoFiltros.tecamarcaid });
    };


    useEffect(() => {
        getFabricanteListAction();
        getClassificacaoListAction();
    }, [])



    const safeString = (v) => {
        try {
            // String(null) -> "null", mas preferimos '' para null/undefined
            if (v === null || v === undefined) return '';
            // Se for objeto (ex: { id: 123 }), tenta extrair algo útil — senão transforma em JSON simples
            if (typeof v === 'object') {
                // se tiver campo comum sku/valor/produto dentro do objeto, adapte aqui:
                // return String(v.sku ?? v.id ?? JSON.stringify(v));
                return JSON.stringify(v);
            }
            return String(v);
        } catch (err) {
            return '';
        }
    };

    // selecionar individual
    const handleSelecionar = (sku, tecaatributovalorid) => {
        setSelecionados(prev => {
            const exists = prev.some(i =>
                i.sku === sku && i.tecaatributovalorid === tecaatributovalorid
            );

            if (exists) {
                return prev.filter(i => !(i.sku === sku && i.tecaatributovalorid === tecaatributovalorid));
            }

            return [...prev, { sku, tecaatributovalorid }];
        });
    };



    // selecionar/desselecionar todos — atua apenas nos itens visíveis (dataFiltrada)
    const handleSelecionarTodos = (_, data) => {
        const marcado = data.checked;
        setTodosSelecionados(marcado);
        if (marcado) {
            setSelecionados(prev => {
                const itensVisiveis = aplicarestbusca.map(item => ({
                    sku: item.sku || item.SKU,
                    tecaatributovalorid: item.tecaatributovalorid || item.TECAATRIBUTOVALORID || null
                }));

                return itensVisiveis.reduce((acc, item) => {
                    const exists = acc.some(i =>
                        i.sku === item.sku && i.tecaatributovalorid === item.tecaatributovalorid
                    );

                    return exists ? acc : [...acc, item];
                }, prev);
            });
        } else {
            setSelecionados(prev => prev.filter(selecionado =>
                !aplicarestbusca.some(item => (item.sku || item.SKU) === selecionado.sku)
            ));
        }
    };

    const handleGeralBuscar = () => {
        console.log('fabricante:', filtrosFabricanteBusca.tecafabricanteid, 'tecamarca:', filtrosMarcaBusca.tecamarcaid, 'tecalinha:', filtrosLinhaBusca.tecalinhaid, 'classificacao:', filtrosClassificacaoBusca.classificacaoid);


        getAplicarEstBuscaAction({
            tecafabricanteid: filtrosFabricanteBusca.tecafabricanteid,
            tecamarcaid: filtrosMarcaBusca.tecamarcaid,
            tecalinhaid: filtrosLinhaBusca.tecalinhaid,
            classificacaoid: filtrosClassificacaoBusca.classificacaoid,
            sku,
            produto,
            categoria,
            valor: valorFiltro,
            titulo: produto
        });
    }

    const handleExcluirSku = (skuValue, atributovalorId) => {
        console.log('Excluir SKU:', skuValue, 'AtributoValorID:', atributovalorId);
        getAtributoDeleteAction(skuValue, atributovalorId).then(() => {
            setOpenModalExcluirSKU(false);
        });
    };

    const handleEditarSku = () => {
        setLoadingEditar(true)
        const dataAtualizar = {
            itens: selecionados.map(item => ({
                ...item,
                tecaatributovaloridatual: valorParaInputId // ← adiciona o novo ID em cada item
            }))
        };

        // Envia para sua action
        getAtributoUpdateAction(dataAtualizar).then(() => {
            setLoadingEditar(false);
            setSelectedSku(false)
            setSelecionados([]); // opcional → limpa seleção após salvar
            getAtriutoAplicarListAction(primeiroAtributoItem.tecaatributoid, valorParaInput);
            getAtributoGeralAction(sku, categoria, valorFiltro, primeiroAtributoItem.tecaatributoid, primeiroAtributoItem.tecaatributoid);
        });
    };

    const handleAplicarEstrutura = () => {
        if (!filtrosFabricante.tecafabricanteid || !filtrosMarca.tecamarcaid) {
            window.alert('Selecione fabricante e marca antes de aplicar os produtos.');
            return;
        }

        const itensSelecionados = selecionados
            .map(item => ({ sku: item.sku || item.SKU }))
            .filter(item => item.sku);

        if (itensSelecionados.length === 0) {
            window.alert('Selecione ao menos um produto para aplicar.');
            return;
        }

        setLoadingEditar(true);

        const dataAplicar = {
            tecafabricanteid: filtrosFabricante.tecafabricanteid,
            tecamarcaid: filtrosMarca.tecamarcaid,
            tecalinhaid: filtrosLinha.tecalinhaid,
            classificacaoid: filtrosClassificacao.classificacaoid || null,
            itens: itensSelecionados
        };

        postAplicarEstAplicaAction(dataAplicar).then((res) => {
            const retorno = Array.isArray(res) ? res[0] : null;
            const status = String(retorno?.status || retorno?.STATUS || '').toLowerCase();

            if (status === 'erro') {
                window.alert(retorno?.message || retorno?.MESSAGE || 'Erro ao aplicar produtos na estrutura.');
                return;
            }

            setSelectedSku(false);
            setSelecionados([]);
            setTodosSelecionados(false);
            getAplicarEstAction({
                tecafabricanteid: filtrosFabricante.tecafabricanteid,
                tecamarcaid: filtrosMarca.tecamarcaid,
                tecalinhaid: filtrosLinha.tecalinhaid,
                classificacaoid: filtrosClassificacao.classificacaoid
            });
            handleGeralBuscar();
        }).catch(() => {
            window.alert('Erro ao aplicar produtos na estrutura.');
        }).finally(() => {
            setLoadingEditar(false);
        });
    };


    const atributosFiltrados = atributosAplicarGeral.filter(
        item => item.tecaatributovalor !== valorParaInput
    );

    const fabricanteOptions = fabricanteList?.map((item) => ({
        key: item.tecafabricanteid,
        text: item.tecafabricante,
        value: item.tecafabricante
    })) || [];

    const marcaOptions = marcaList?.map((item) => ({
        key: item.tecamarcaid,
        text: item.tecamarca,
        value: item.tecamarcaid
    })) || [];

    const classificacaoOptions = classificacaoList?.map((item) => ({
        key: item.classificacaoid,
        text: item.classificacao,
        value: item.classificacaoid
    })) || [];

    const linhaOptions = linhalist?.map((item) => ({
        key: item.tecalinhaid,
        text: item.tecalinha,
        value: item.tecalinhaid
    })) || [];

    return (
        <div ref={rootRef}>
            {/* MODAL */}
            <Modal open={openModalExcluirSKU} onClose={() => setOpenModalExcluirSKU(false)}>
                <StyledModalHeader>
                    <ModalTitle>Confirmar Exclusão de SKU</ModalTitle>
                </StyledModalHeader>

                <StyledModalContent>
                    <p>Tem certeza de que deseja excluir o SKU: <b>{skuExcluir}</b> da aplicação do atributo?</p>
                </StyledModalContent>
                <StyledModalActions>
                    <Button onClick={() => setOpenModalExcluirSKU(false)}>Cancelar</Button>
                    <Button loading={atributosAplicarDeleteLoading} onClick={() => handleExcluirSku(skuExcluir, atributoValorIdExcluir)} negative>Excluir</Button>
                </StyledModalActions>
            </Modal>
            <Modal open={openModalEditar} onClose={() => setOpenModalEditar(false)}>
                <StyledModalHeader>
                    <ModalTitle>Confirmar Edição de SKU</ModalTitle>
                </StyledModalHeader>

                <StyledModalContent>
                    <p>Tem certeza de que deseja editar o(s) SKU(s): <b>{selecionados.join(", ")}</b> <b>{skuExcluir}</b> e aplicar no atributo: <b>atributo-observacao</b>?</p>
                </StyledModalContent>
                <StyledModalActions>
                    <Button onClick={() => setOpenModalEditar(false)}>Cancelar</Button>
                    <Button loading={atributosAplicarEditLoading} onClick={() => handleEditarSku(selecionados.join(", "))} color='green'>Editar</Button>
                </StyledModalActions>
            </Modal>

            {/* HEADER INFOS */}
            <div>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                        <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                            <span style={{ marginLeft: '-10px' }}>
                                Fabricante:{' '}
                            </span>
                            <CustomDropdown
                                style={{ width: '80%' }}
                                placeholder="Fabricante"
                                fluid
                                selection
                                clearable
                                search
                                options={fabricanteOptions}
                                loading={fabricanteListLoading}
                                name="Fabricante"
                                value={filtrosFabricante.tecafabricante || ''}   // <--- chave correta
                                onChange={handleChange}
                            />
                        </div>
                        <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                            <span style={{ marginRight: '5px' }}>
                                Marca:
                            </span>
                            <CustomDropdown
                                style={{ width: '80%' }}
                                placeholder="Marca"
                                fluid
                                selection
                                clearable
                                search
                                disabled={filtrosFabricante.tecafabricante === '' ? true : false}
                                loading={marcaListLoading}
                                options={marcaOptions}
                                name="Marca"
                                value={filtrosMarca.tecamarcaid || ''}   // <--- chave correta
                                onChange={handleChangeMarca}
                            />
                        </div>
                    </div>
                    <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <span style={{ marginRight: '24px' }}> Linha:</span>
                            <CustomDropdown
                                style={{ width: '80%' }}
                                placeholder="Linha"
                                fluid
                                selection
                                clearable
                                search
                                loading={linhalistLoading}
                                disabled={filtrosMarca.tecamarca === '' || linhalist.lenght === 0 ? true : false}
                                options={linhaOptions}
                                name="Linha"
                                value={filtrosLinha.tecalinhaid || ''}   // <--- chave correta
                                onChange={handleChangeLinha}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <span style={{ marginLeft: '-40px', marginRight: '5px' }}>Classificação: </span>
                            <CustomDropdown
                                style={{ width: '80%' }}
                                placeholder="Classificação"
                                fluid
                                selection
                                clearable
                                search
                                options={classificacaoOptions}
                                name="Classificacao"
                                value={filtrosClassificacao.classificacaoid || ''}   // <--- chave correta
                                onChange={handleChangeClassificacao}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {aplicarlistloading === false ? (
                <>
                    <Container ref={firstTableRef}>
                        <Table>
                            <thead>
                                <tr>
                                    <Th>SKU</Th>
                                    <Th>Produto</Th>
                                    <Th>Fabricante</Th>
                                    <Th>Marca</Th>
                                    <Th>Linha</Th>
                                    <Th>Categoria/Classificação</Th>
                                    <Th></Th>
                                </tr>
                            </thead>
                            <tbody>
                                {listaSegura.map((item, index) => (
                                    <tr key={item.SKU ?? index}>
                                        <Td>{item.SKU}</Td>
                                        <Td>{item.nomeproduto}</Td>
                                        <Td>{item.fabricante}</Td>
                                        <Td>{item.marca}</Td>
                                        <Td>{exibeValorOuTraco(item.linha)}</Td>
                                        <Td>{item.classificacao}</Td>
                                        <Td></Td>
                                        {/* <Td>
                                            <Status valorParaInput={valorParaInput} value={item.tecaatributovalor}>
                                                {item.tecaatributovalor}
                                            </Status>
                                        </Td> */}
                                        {/* <Td style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <ActionButton onClick={() => { console.log('Clicou no botão excluir do SKU', item.sku); setOpenModalExcluirSKU(true); setSkuExcluir(item.sku); setAtributoValorIdExcluir(item.tecaatributovalorid) }}>
                                                <Icon name="trash alternate outline" /> Excluir
                                            </ActionButton>
                                        </Td> */}
                                    </tr>
                                ))}
                                {listaSegura.length === 0 && (
                                    <tr>
                                        <Td colSpan={7} style={{ textAlign: 'center', padding: 20, color: '#666' }}>
                                            {atributosAplicarListLoading ? 'Carregando...' : 'Nenhum item disponível.'}
                                        </Td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Container>
                </>

            ) : (
                <div>
                    <Dimmer active inverted>
                        <Loader inverted>Carregando...</Loader>
                    </Dimmer>
                </div>
            )}

            {/* PRIMEIRA TABELA */}


            <hr />

            {/* FILTROS PARA BUSCA */}


            <div>
                <p style={{ color: '#102E3E', fontWeight: 'bold' }}>Busca para identificar novos produtos a serem APLICADOS</p>
            </div>

            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                    <span style={{ marginLeft: '-10px' }}>
                        Fabricante:{' '}
                    </span>
                    <CustomDropdown
                        style={{ width: '80%' }}
                        placeholder="Fabricante"
                        fluid
                        selection
                        clearable
                        search
                        options={fabricanteOptions}
                        name="FabricanteBusca"

                        value={filtrosFabricanteBusca.tecafabricante || ''}   // <--- chave correta
                        onChange={handleChangeBusca}
                    />
                </div>
                <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px' }}>
                        Marca:
                    </span>
                    <CustomDropdown
                        style={{ width: '80%' }}
                        placeholder="Marca"
                        fluid
                        selection
                        clearable
                        search
                        options={marcaOptions}
                        name="MarcaBusca"
                        value={filtrosMarcaBusca.tecamarcaid || ''}   // <--- chave correta
                        onChange={handleChangeMarcaBusca}
                    />
                </div>
            </div>
            <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <span style={{ marginRight: '24px' }}> Linha:</span>
                    <CustomDropdown
                        style={{ width: '80%' }}
                        placeholder="Linha"
                        fluid
                        selection
                        clearable
                        search
                        options={linhaOptions}
                        name="LinhaBusca"
                        value={filtrosLinhaBusca.tecalinhaid || ''}   // <--- chave correta
                        onChange={handleChangeLinhaBusca}
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <span style={{ marginLeft: '-40px', marginRight: '5px' }}>Classificação: </span>
                    <CustomDropdown
                        style={{ width: '80%' }}
                        placeholder="Classificação"
                        fluid
                        selection
                        clearable
                        search
                        options={classificacaoOptions}
                        name="ClassificacaoBusca"
                        value={filtrosClassificacaoBusca.classificacaoid || ''}   // <--- chave correta
                        onChange={handleChangeClassificacaoBusca}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 20, gap: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: 10, fontWeight: 'bold' }}>SKU:</span>
                    <Input value={sku} onChange={(e) => setSku(e.target.value)} placeholder="SKU" />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: 10, fontWeight: 'bold' }}>Produto:</span>
                    <Input value={produto} onChange={(e) => setProduto(e.target.value)} placeholder="Produto" />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: 10, fontWeight: 'bold' }}>Categoria/Classificação:</span>
                    <Input value={categoria} onChange={(e) => setCategoria(e.target.value)} placeholder="Categoria/Classificação" />
                </div>
                {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: 10, fontWeight: 'bold' }}>Valor:</span>
                    <Input
                        placeholder="Valor"
                        value={usarMesmoValor ? (valorParaInput || '') : valorFiltro}
                        onChange={(e) => setValorFiltro(e.target.value)}
                        disabled={usarMesmoValor}
                    />
                </div> */}

                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button onClick={() => handleGeralBuscar()} style={{ backgroundColor: '#0078d7', color: '#fff' }}>Buscar <Icon name="search" style={{ marginLeft: '5px' }} /></Button>
                </div>
            </div>

            <Container ref={secondTableRef}>
                <Table>
                    <thead>
                        <tr>
                            <Th>SKU</Th>
                            <Th>Produto</Th>
                            <Th>Fabricante</Th>
                            <Th>Marca</Th>
                            <Th>Linha</Th>
                            <Th>Categoria/Classificação</Th>
                            <Th>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <span style={{ marginRight: 5, width: '100px' }}>Selecionar Tudo</span>
                                    <Checkbox
                                        checked={todosSelecionados}
                                        onChange={handleSelecionarTodos}
                                    // disabled={dataFiltrada.length === 0}
                                    />
                                </div>
                            </Th>
                        </tr>
                    </thead>

                    <tbody>
                        {aplicarestbusca.map((item, index) => {
                            const itemSku = item.sku || item.SKU;
                            const itemAtributoValorId = item.tecaatributovalorid || item.TECAATRIBUTOVALORID || null;
                            const isSelected = selecionados.some(i =>
                                i.sku === itemSku && i.tecaatributovalorid === itemAtributoValorId
                            );
                            return (
                                !aplicarbuscalistloading && (
                                    <Tr key={`${itemSku}-${item.tecaatributovalor}-${index}`} selected={isSelected}>
                                        <Td>{itemSku}</Td>
                                        <Td>{item.nomeproduto}</Td>
                                        <Td>{item.fabricante}</Td>
                                        <Td>{item.marca}</Td>
                                        <Td>{exibeValorOuTraco(item.linha)}</Td>
                                        <Td>{item.categoria || item.classificacao}</Td>
                                        <Td>
                                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <ActionButtonSelect
                                                    selected={isSelected}
                                                    onClick={() => {
                                                        handleSelecionar(itemSku, itemAtributoValorId);
                                                        console.log('DADOS ->', itemSku, itemAtributoValorId, valorParaInputId);
                                                    }}
                                                >
                                                    {isSelected ? 'Cancelar' : 'Selecionar'}
                                                </ActionButtonSelect>
                                            </div>
                                        </Td>
                                        {/* <Td style={{ width: '300px' }}>
                                            <Status valorParaInput={valorParaInput} value={item.tecaatributovalor}>
                                                {item.tecaatributovalor}
                                            </Status>
                                        </Td> */}
                                        {/* <Td>
                                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <ActionButtonSelect
                                                    selected={isSelected}
                                                    onClick={() => {
                                                        handleSelecionar(item.sku, item.tecaatributovalorid);
                                                        console.log('DADOS ->', item.sku, item.tecaatributovalorid, valorParaInputId);
                                                    }}
                                                >
                                                    {isSelected ? 'Cancelar' : 'Selecionar'}
                                                </ActionButtonSelect>
                                            </div>
                                        </Td> */}
                                    </Tr>
                                )
                            );
                        })}
                        {aplicarestbusca.length === 0 && (
                            !aplicarbuscalistloading && (
                                sku ? (
                                    <>
                                        <tr>
                                            <Td></Td>
                                            <Td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#666' }}>
                                                Nenhum item encontrado para o Sku informado, deseja aplicá-lo no valor atual?
                                            </Td>
                                            <Td></Td>
                                        </tr>
                                        <Tr selected={selectedSku}>
                                            <Td>{sku}</Td>
                                            <Td>-</Td>
                                            <Td></Td>
                                            <Td></Td>
                                            <Td></Td>
                                            <Td>
                                                Sem Estrutura
                                            </Td>
                                            <Td>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <ActionButtonSelect
                                                        selected={selectedSku}
                                                        onClick={() => {
                                                            handleSelecionar(sku, null);
                                                            setSelectedSku(!selectedSku);
                                                            console.log('DADOS ->', sku, null, valorParaInputId);
                                                        }}
                                                    >
                                                        {selectedSku ? 'Cancelar' : 'Selecionar'}
                                                    </ActionButtonSelect>
                                                </div>
                                            </Td>
                                        </Tr>
                                    </>

                                ) : (
                                    <tr>
                                        <Td colSpan={7} style={{ textAlign: 'center', padding: 20, color: '#666' }}>
                                            Nenhum item encontrado para o filtro informado.
                                        </Td>
                                    </tr>
                                )
                            )
                        )}
                        {aplicarbuscalistloading && (
                            <tr>
                                <Td colSpan={7} style={{ textAlign: 'center', color: '#666' }}>
                                    <div>
                                        <Loader style={{ marginTop: '200px' }} active>carregando...</Loader>
                                    </div>
                                </Td>
                            </tr>
                        )}

                    </tbody>
                </Table>
            </Container>

            {/* BOTÃO FINAL */}
            <div style={{ marginTop: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Button
                    style={{ backgroundColor: '#0078FF', color: 'white' }}
                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0063CC')}
                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#0078FF')}
                    onClick={() => handleAplicarEstrutura()}
                    disabled={selecionados.length > 0 ? false : true}
                    loading={loadingEditar}
                >
                    Acrescentar Produtos <Icon name='long arrow alternate up' color='white' />
                </Button>

            </div>
        </div>
    );
}

// Conecta ao Redux
const mapStateToProps = (state) => ({
    tabindex: state.EspacoTecaReducer.tabindex,
    userid: state.LoginReducer.userid,
    atributosItemList: state.EspacoTecaReducer.atributosItemList,
    atributosList: state.EspacoTecaReducer.atributosList,
    atributoSelecionado: state.EspacoTecaReducer.atributoSelecionado,
    atributosAplicarList: state.EspacoTecaReducer.atributosAplicarList,
    atributosAplicarListLoading: state.EspacoTecaReducer.atributosAplicarListLoading,
    atributosAplicarGeral: state.EspacoTecaReducer.atributosAplicarGeral,
    atributosAplicarGeralLoading: state.EspacoTecaReducer.atributosAplicarGeralLoading,
    atributosAplicarDelete: state.EspacoTecaReducer.atributosAplicarDelete,
    atributosAplicarDeleteLoading: state.EspacoTecaReducer.atributosAplicarDeleteLoading,
    atributosAplicarEdit: state.EspacoTecaReducer.atributosAplicarEdit,
    atributosAplicarEditLoading: state.EspacoTecaReducer.atributosAplicarEditLoading,
    fabricanteList: state.EspacoTecaReducer.fabricanteList,
    fabricanteListLoading: state.EspacoTecaReducer.fabricanteListLoading,
    classificacaoList: state.EspacoTecaReducer.classificacaoList,
    classificacaoListLoading: state.EspacoTecaReducer.classificacaoListLoading,
    marcaList: state.EspacoTecaReducer.marcaList,
    marcaListLoading: state.EspacoTecaReducer.marcaListLoading,
    linhalist: state.EspacoTecaReducer.linhalist,
    linhalistLoading: state.EspacoTecaReducer.linhalistLoading,
    aplicarlistloading: state.EspacoTecaReducer.aplicarlistloading,
    aplicarest: state.EspacoTecaReducer.aplicarest,
    aplicarbuscalistloading: state.EspacoTecaReducer.aplicarbuscalistloading,
    aplicarestbusca: state.EspacoTecaReducer.aplicarestbusca,
});

export default withRouter(connect(mapStateToProps, {
    getAtriutoAplicarListAction, getAtributoGeralAction, getAtributoDeleteAction, getAtributoUpdateAction, getFabricanteListAction, getMarcaListAction, getLinhaListAction, getClassificacaoListAction
    , getAplicarEstAction, getAplicarEstBuscaAction, postAplicarEstAplicaAction
})(AplicarEst));
